export default __webpack_public_path__ + "static/media/Q5_4.581b3bed.png";